function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_awesome-handshake",
  "data-name": "Icon awesome-handshake",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-handshake-2",
  "data-name": "Icon awesome-handshake",
  d: "M63.371,4.5H50.848A4.663,4.663,0,0,0,47.7,5.725l-14.33,13.12c-.015.015-.029.044-.044.058a5.8,5.8,0,0,0-.306,8.164,6.08,6.08,0,0,0,8.178.394c.015-.015.044-.015.058-.029L52.9,16.76a2.332,2.332,0,1,1,3.149,3.44l-3.8,3.484L73.473,40.916a10.5,10.5,0,0,1,1.152,1.123V13.83l-7.96-7.96A4.631,4.631,0,0,0,63.371,4.5ZM79.3,13.859V46.5a4.66,4.66,0,0,0,4.665,4.665H93.3V13.859Zm7,32.64a2.332,2.332,0,1,1,2.332-2.332A2.339,2.339,0,0,1,86.3,46.5ZM0,51.15H9.33a4.66,4.66,0,0,0,4.665-4.665V13.859H0Zm7-9.315a2.332,2.332,0,1,1-2.332,2.332A2.339,2.339,0,0,1,7,41.834Zm63.546,2.712L48.778,26.877,44.4,30.886A10.493,10.493,0,0,1,30.22,15.419L42.145,4.5H29.929a4.657,4.657,0,0,0-3.295,1.37L18.66,13.83V46.47h2.668L34.521,58.41a9.328,9.328,0,0,0,13.12-1.356l.029-.029,2.609,2.26A5.418,5.418,0,0,0,57.9,58.5l4.578-5.627.787.641a4.658,4.658,0,0,0,6.56-.685l1.385-1.706a4.673,4.673,0,0,0-.671-6.575Z",
  transform: "translate(0 -4.5)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}));

function SvgHandShake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.299,
    height: 57.005,
    viewBox: "0 0 94.299 57.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandShake);
export default __webpack_public_path__ + "static/media/HandShake.2205d5a3ff90322c85a43c22c21257a2.svg";
export { ForwardRef as ReactComponent };